import {
    
  update_lead_list
    
} from '@/api/leads'
export const LeadMixin = {
  methods:{
    checkingValueChange (oldValue, newValue) {
      return oldValue === newValue
      
    },
    onCellValueChanged (params) {
      console.log(params)
      const data = {}
      data.colId = params.column.getId()
      data.leads_id = params.data.leads_id

      const hasCheckingValueChange = this.checkingValueChange(params.oldValue, params.newValue)
      

      if (!hasCheckingValueChange) {

  
        if (data.colId === 'lead_last_name') {
          data.fieldvalue = params.data.lead_last_name
          if (!data.fieldvalue.length) {
            this.showSuccessMessage('Warning', 'Name field can not be empty', 'warning')
            this.revertOldValue(params.rowIndex, data.colId, params.oldValue)
            return false
          }
        } else if (data.colId === 'email') {
          data.fieldvalue = params.data.email
          const hasCheckingEmail = this.ValidateEmail(params.data.email)
          if (!hasCheckingEmail) {

            this.revertOldValue(params.rowIndex, data.colId, params.oldValue)
            this.showSuccessMessage('Warning', 'Email Not Validated', 'warning')
            return false
          }
        } else if (data.colId === 'lead_middle_name') {
          data.fieldvalue = params.data.lead_middle_name
          if (!data.fieldvalue.length) {

            this.showSuccessMessage('Warning', 'No changes has been made', 'warning')
            this.revertOldValue(params.rowIndex, data.colId, params.oldValue)
            return false

          }
        } else if (data.colId === 'phone') {
          const phoneno = /^\d+$/
          data.fieldvalue = params.data.phone
  
          if (data.fieldvalue.match(phoneno)) {
            data.fieldvalue = params.data.phone
          } else {
            this.showSuccessMessage('Warning', 'Phone field can not be empty', 'warning')
            this.revertOldValue(params.rowIndex, data.colId, params.oldValue)
            return false
          }
        } else if (data.colId === 'lead_city') {
          data.fieldvalue = params.data.lead_city
          if (!data.fieldvalue.length) {
            this.showSuccessMessage('Warning', 'No changes has been made', 'warning')
            this.revertOldValue(params.rowIndex, data.colId, params.oldValue)
            return false
          }
        } else if (data.colId === 'lead_zip') {
          data.fieldvalue = params.data.lead_zip
          if (!data.fieldvalue.length) {
            this.showSuccessMessage('Warning', 'No changes has been made', 'warning')
            this.revertOldValue(params.rowIndex, data.colId, params.oldValue)
            return false
          }
        } else if (data.colId === 'lead_state') {
          data.fieldvalue = params.data.lead_state
          if (!data.fieldvalue.length) {
            this.showSuccessMessage('Warning', 'No changes has been made', 'warning')
            this.revertOldValue(params.rowIndex, data.colId, params.oldValue)
            return false
          }
        } else {
          console.log(params)
          if (params.colDef.input_type === 'number') {
            const numdynamic = /^\d+$/
            data.fieldvalue = params.data[data.colId]
          
            if (data.fieldvalue.match(numdynamic)) {
              data.fieldvalue = params.data[data.colId]
            } else {
              this.showSuccessMessage('Warning', 'This field can not be string', 'warning')
              this.revertOldValue(params.rowIndex, data.colId, params.oldValue)
              return false
            }
          } else {
            data.fieldvalue = params.data[data.colId]
            if (!data.fieldvalue.length) {
              this.showSuccessMessage('Warning', 'This field can not be empty', 'warning')
              this.revertOldValue(params.rowIndex, data.colId, params.oldValue)
              return false
            }
          }
         
        }
        const hasDataUpdated = this.update_lead(data, params.rowIndex, params.oldValue)
        hasDataUpdated.then(res => {
          if (!res) {
            this.gridOptions.api.stopEditing()

          }
          
        })
      } else {
        this.showSuccessMessage('Warning', 'No changes has been made', 'warning')
      }
    },
    async update_lead (data, index, oldValue) {
      const payload = {
        leads_id: [data.leads_id],
        update_field: {
          [data.colId]: data.fieldvalue
        },
        customer_id: localStorage.getItem('customer_id')
      }
  
      try {
        // 
        const { data } = await update_lead_list(payload)
        this.showSuccessMessage('Success', `${data.message}`, 'success')

        return true
      
      } catch (api_error) {
        
        
        this.tableData[index][data.colId] = oldValue 

        this.gridOptions.api.refreshCells() 

        
        // 
        if ('email' in api_error.data.errors) {
          this.showSuccessMessage('Warning', `${api_error.data.errors.email[0]}`, 'warning')
        } else if ('phone' in api_error.data.errors) {
          this.showSuccessMessage('Warning', `${api_error.data.errors.phone[0]}`, 'warning')
        }  
        return false
      }
    },
    revertOldValue (index, field, value) {
      this.tableData[index][field] = value 
      
      this.gridOptions.api.refreshCells() 
    }
   
  }
}